import { combineReducers } from "redux";
import umbracoPageReducer from "./umbraco/redux/page.reducer";
import umbracoSettingsReducer from "./umbraco/redux/settings.reducer";
import overlayReducer from "layout/redux/overlay.reducer";
import dictionaryReducer from "components/Dictionary/redux/dictionary.reducer";
import { connectRouter } from "connected-react-router";
import { History } from "history";

export const reducer = (history: History): any => combineReducers({
    dictionary: dictionaryReducer,
    overlay: overlayReducer,
    page: umbracoPageReducer,
    router: connectRouter(history),
    settings: umbracoSettingsReducer
});

export type AppRootState = ReturnType<typeof reducer>;